export default __webpack_public_path__ + "static/media/iconeEscopoDeQualificaçãoMaior.f461ff85.png";